var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){_vm.showMe=true}}},[_vm._v(_vm._s(_vm.tabName))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMe),expression:"showMe"}]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }